import SectionHeading from "@/pages/home/components/SectionHeading";
import { efficiencyTips } from "@/mocks/content";

export default function EfficiencyTips() {
  return (
    <section id="tips" className="w-full bg-background-50 py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="刷视频看直播效率指南"
          title="六个习惯，让你少刷无用内容"
          desc="平台内容量大，方法比体力更重要。下面六条是实用的小技巧，围绕关注、标签、清晰度和提醒来组织浏览习惯。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {efficiencyTips.map((t, i) => (
            <article
              key={t.title}
              className="rounded-lg bg-background-100 border border-background-200/80 p-5 md:p-6 hover:border-accent-400 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-800 text-xl">
                  <i className={t.icon}></i>
                </span>
                <span className="font-heading font-black text-2xl text-background-300">0{i + 1}</span>
              </div>
              <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">{t.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{t.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}